import { Flex, FlexProps, Text, TextProps } from "@chakra-ui/react";

import InfoIconTooltip from "@/common/components/InfoIconTooltip";

export const unavailableRolloutCountText =
  "Audience counts are disabled for flags with percentage rollouts in this environment due to performance.";

const sharedAudienceCountTextProps = {
  as: "span",
  color: "dimmed",
  fontSize: "sm",
  lineHeight: "21px",
} satisfies TextProps;

type AudienceCountUnavailableProps = FlexProps & {
  renderTooltipInPortal?: boolean;
  textProps?: TextProps;
};

export function AudienceCountUnavailable({
  renderTooltipInPortal = false,
  textProps,
  ...rest
}: AudienceCountUnavailableProps) {
  return (
    <Flex align="center" gap={1} {...rest}>
      <Text {...sharedAudienceCountTextProps} {...textProps}>
        Audience count unavailable
      </Text>
      <InfoIconTooltip
        renderInPortal={renderTooltipInPortal}
        text={unavailableRolloutCountText}
      />
    </Flex>
  );
}
